import { S as ShoppingCartView$1, d as defineCustomElement$1 } from './shopping-cart-view2.js';
const ShoppingCartView = ShoppingCartView$1;
const defineCustomElement = defineCustomElement$1;
export { ShoppingCartView, defineCustomElement };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOltdLCJzb3VyY2VzQ29udGVudCI6W10sIm1hcHBpbmdzIjoiIiwiaWdub3JlTGlzdCI6W119